import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import { RenderField, RenderDatePicker, RenderCheckboxRadioField, RenderTextareaField, RenderSubmitButton } from '../../form';
import * as Validations from '../../form/commonValidations';
import { editTask, unselectTask, fetchChecklist, fetchStats } from '../../../../actions/ChecklistActions';
import { showModal, hideModal } from '../../../../actions/ModalActions'; // eslint-disable-line

const EditTaskFormModal = ({ handleSubmit, pristine, submitting, valid, task, onDeleteTask, onCloseForm }) => (
  <div className="table checklist-table">
    <form onSubmit={handleSubmit} className="edit-task-form">
      <div className="modal-header">
        <button type="button" className="modal-close" onClick={onCloseForm}>×</button>
      </div>
      <div className="modal-body">
        <div className="form-group">
          <Field
            id="checklist-task-completed"
            name="completed"
            component={RenderCheckboxRadioField}
            type="checkbox"
            value
            label="Mark As Completed"
            styleOverride
            className="checkbox-tertiary"
          />
        </div>
        {task && task.checklist_template_task_id && (
          <div className="form-group">
            <h4>{task.title}</h4>
            <p>{task.description}</p>
            {task.url && (
              <a href={task.url} className="btn btn-secondary">{task.url_text || 'Get Started'}</a>
            )}
          </div>
        )}
        {task && !task.checklist_template_task_id && (
          <Field
            name="title"
            type="text"
            id="checklist-task-title"
            required
            component={RenderField}
            validate={Validations.REQUIRED}
            label="Title"
          />
        )}
        <Field
          name="due_at"
          type="date"
          id="checklist-task-due-at"
          component={RenderDatePicker}
          placeholder="MM/DD/YYYY"
          required
          validate={[Validations.REQUIRED, Validations.DATE]}
          label="Due Date"
        />
        <Field
          component={RenderTextareaField}
          name="notes"
          label="Your Notes"
          id="checklist-task-notes"
          placeholder="Add a note..."
        />
        <div className="submit-buttons">
          <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} className="btn-block" hideFormGroup />
          <a role="button" onClick={() => onDeleteTask(task.id)} className="btn btn-secondary btn-block">Delete</a>
        </div>
      </div>
    </form>
  </div>
);

EditTaskFormModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  task: PropTypes.shape({}),
  onDeleteTask: PropTypes.func.isRequired,
  onCloseForm: PropTypes.func
};

const mapStateToProps = (state, ownProps) => (
  {
    initialValues: (ownProps.taskId && state.checklist.tasks.byId[ownProps.taskId]) ? {
      ...state.checklist.tasks.byId[ownProps.taskId],
      due_at: moment.utc(state.checklist.tasks.byId[ownProps.taskId].due_at),
      completed: state.checklist.tasks.byId[ownProps.taskId].completed_at !== null
    } : {},
    task: ownProps.taskId && state.checklist.tasks.byId[ownProps.taskId]
  }
);

const mapDispatchToProps = dispatch => (
  {
    // dispatch2 is a place holder - without it, onSubmit crashes. themoreyouknow.jpeg
    onSubmit: (editTaskRequest, dispatch2, props) => {
      const initialDueAt = props.initialValues.due_at;
      const requestDueAt = moment.utc(editTaskRequest.due_at);

      return dispatch(editTask(editTaskRequest)).then(() => {
        dispatch(unselectTask());

        if (initialDueAt.isSame(requestDueAt, 'day')) {
          dispatch(fetchStats());
          dispatch(hideModal());
        } else {
          dispatch(fetchChecklist());
          dispatch(hideModal());
        }
      });
    },
    onDeleteTask: taskId => dispatch(showModal('DELETE_CHECKLIST_TASK', { taskId, callback: () => dispatch(unselectTask()) })),
    onCloseForm: () => {
      dispatch(unselectTask());
      dispatch(hideModal());
    }
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'EditTaskFormModal',
  enableReinitialize: true
})(EditTaskFormModal));



// WEBPACK FOOTER //
// ./src/components/common/modals/EditTaskFormModal/EditTaskFormModal.jsx